import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function More(): React.ReactElement {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#more_icon)">
        <path d="M17.55 9.02969C17.55 10.299 16.5211 11.3279 15.2518 11.3279C13.9825 11.3279 12.9536 10.299 12.9536 9.02969C12.9536 7.76058 13.9825 6.73151 15.2518 6.73151C16.5211 6.73151 17.55 7.76058 17.55 9.02969Z" />
        <path d="M11.2981 9.02969C11.2981 10.299 10.2692 11.3279 8.99991 11.3279C7.73079 11.3279 6.70172 10.299 6.70172 9.02969C6.70172 7.76058 7.73079 6.73151 8.99991 6.73151C10.2692 6.73151 11.2981 7.76058 11.2981 9.02969Z" />
        <path d="M5.04639 9.02969C5.04639 10.299 4.0175 11.3279 2.7482 11.3279C1.4789 11.3279 0.450012 10.299 0.450012 9.02969C0.450012 7.76058 1.4789 6.73151 2.7482 6.73151C4.0175 6.73151 5.04639 7.76058 5.04639 9.02969Z" />
      </g>
      <defs>
        <clipPath id="more_icon">
          <rect width="17.1" height="17.1" transform="translate(0.450012 0.450012)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
